var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupleFriendlyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02117 7.6128C7.02117 9.00548 5.89219 10.1345 4.49951 10.1345C3.10684 10.1345 1.97785 9.00548 1.97785 7.6128C1.97785 6.22013 3.10684 5.09114 4.49951 5.09114C5.89219 5.09114 7.02117 6.22013 7.02117 7.6128Z",
    stroke: "#303030",
    strokeWidth: 0.729167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0669 8.07115C15.0669 9.21214 14.142 10.1371 13.001 10.1371C11.86 10.1371 10.935 9.21214 10.935 8.07115C10.935 6.93016 11.86 6.00521 13.001 6.00521C14.142 6.00521 15.0669 6.93016 15.0669 8.07115Z",
    stroke: "#303030",
    strokeWidth: 0.729167
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.364583 14.5C0.364583 12.2161 2.21607 10.3646 4.5 10.3646C6.78393 10.3646 8.63542 12.2161 8.63542 14.5V14.6354H0.364583V14.5Z",
    stroke: "#303030",
    strokeWidth: 0.729167
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36458 14C9.36458 11.9922 10.9922 10.3646 13 10.3646C15.0078 10.3646 16.6354 11.9922 16.6354 14V14.6354H9.36458V14Z",
    stroke: "#303030",
    strokeWidth: 0.729167
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4841 1.3554C11.3715 1.24273 11.2378 1.15335 11.0906 1.09237C10.9434 1.03139 10.7857 1 10.6264 1C10.4671 1 10.3093 1.03139 10.1622 1.09237C10.015 1.15335 9.88127 1.24273 9.76865 1.3554L9.53493 1.58912L9.3012 1.3554C9.07372 1.12792 8.76519 1.00012 8.44348 1.00012C8.12177 1.00012 7.81323 1.12792 7.58575 1.3554C7.35827 1.58288 7.23047 1.89142 7.23047 2.21313C7.23047 2.53484 7.35827 2.84337 7.58575 3.07085L7.81948 3.30458L9.53493 5.02003L11.2504 3.30458L11.4841 3.07085C11.5968 2.95823 11.6862 2.82452 11.7471 2.67735C11.8081 2.53018 11.8395 2.37243 11.8395 2.21313C11.8395 2.05382 11.8081 1.89608 11.7471 1.74891C11.6862 1.60173 11.5968 1.46802 11.4841 1.3554Z",
    fill: "#FCB7B7",
    stroke: "#303030",
    strokeWidth: 0.729167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleFriendlyIcon);
export default __webpack_public_path__ + "static/media/coupleFriendlyIcon.63649eea27687e8f568d44ee3c356627.svg";
export { ForwardRef as ReactComponent };